import React from 'react'

import { createDataContext } from 'modules/core/components/DataTable/contexts/DataContext'

const useData = <T, S extends string>() => {
  const Context = createDataContext<T, S>()
  const value = React.useContext(Context)

  if (!value) {
    throw new Error('useData must be used within a DataProvider')
  }

  return value
}

export default useData
